// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumCommentAdd__blockedNotice":"pa_a bho_sn bho_sv bho_sw bho_kx bho_ky bho_ke undefined bho_vt"};